import type { ReactNode } from "react";
import s from "./EmptyState.module.css";

export function EmptyState({ icon, title, children, action }: { icon?: ReactNode; title: string; children?: ReactNode; action?: ReactNode }) {
  return (
    <div className={s.empty}>
      {icon && <div className={s.icon}>{icon}</div>}
      <h2 className={s.title}>{title}</h2>
      {children && <p className={s.text}>{children}</p>}
      {action && <div className={s.action}>{action}</div>}
    </div>
  );
}
